import _ from 'underscore';
import { merge } from '@bingads-webui-universal/primitive-utilities';
import { setFilterByReportEmailRule } from '@bingads-webui-campaign/projection-grid-inline-download';
import { Decorator } from './decorator';

// Values that are not currently provided by the Filter Service,
// but are present in the current filter
const filterOptionsExtensions = {
  dateFormat: 'yyyy-MM-ddTHH:mm:ss',
  shortDateFormat: 'M/d/yyyy',
};

export class FilterDecorator extends Decorator {
  /**
   * Creates an instance of FilterDecorator.
   * @param {any} {
   *     featureName - Name of feature,
   *     filterService - Filter Service instance to use
   *   }
   * @memberof FilterDecorator
   */
  constructor({
    featureName,
    filterService,
    ignoreColumns,
    appConfig,
    appState,
  }) {
    super({ name: 'filter' });

    this.featureName = featureName;
    this.filterService = filterService;
    this.ignoreColumns = ignoreColumns;
    this.appConfig = appConfig;
    this.appState = appState;
  }

  getValueAsync() {
    // If navigated from Report page, set filter from ReportEmailRule
    if (this.appState && this.appConfig) {
      const ReportEmailRule = this.appState.get('$ReportEmailRule');
      if (ReportEmailRule) {
        return setFilterByReportEmailRule({
          appConfig: this.appConfig,
          filterService: this.filterService,
          ReportEmailRule,
        }).then(() => this.filterService.refreshSource())
          .then(() => this.filterService.getCombinedFilter());
      }
    }

    this.filterService.refreshSource();

    return this.filterService.p$Initialized
      .then(() => this.filterService.getCombinedFilter());
  }

  buildQuery(queryParams, filterQuery) {
    const transformedFilterQuery = filterQuery;

    if (!_.isEmpty(this.ignoreColumns) && !_.isEmpty(filterQuery.query)) {
      const keys = filterQuery.query ? _.keys(filterQuery.query) : null;

      if (keys) {
        _.each(keys, (key) => {
          if (_.contains(this.ignoreColumns, key)) {
            delete transformedFilterQuery.query[key];
          }
        });
      }
    }

    if (_.isEmpty(transformedFilterQuery.query)) {
      return queryParams;
    }

    const filterOptions = _.extend(
      {},
      filterOptionsExtensions,
      transformedFilterQuery.odataOptions,
      {
        schema: transformedFilterQuery.schema,
      }
    );

    return merge({}, queryParams, {
      options: { filterOptions },
      where: transformedFilterQuery.query,
    });
  }
}
